import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
}

const ChevronDown: React.FC<PropsT> = ({ className, fillColor = 'white' }) => (
  <svg
    className={className}
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.37165 4.58706C4.17303 4.80775 3.82697 4.80775 3.62835 4.58706L0.251035 0.834483C-0.0385505 0.512722 0.189796 0 0.622681 0H7.37732C7.8102 0 8.03855 0.512721 7.74897 0.834482L4.37165 4.58706Z"
      fill={fillColor}
    />
  </svg>
)

export default ChevronDown
